import axios from "../utils/axios";

export const fetchDidacticYears = async () => {
  const res = await axios.get("/didacticyear").catch((error) => {
    if (error.response) {
      console.error(error);
    }
  });

  return res.data;
};
